<template>
	<el-header>
		<div class="grid-content nav-bg-color">
				<!-- nav -->
			<div class="nav-main">
					<el-menu mode="horizontal" background-color="#060D27" text-color="#fff" active-text-color="#fff">
						<el-menu-item index="0">
							<router-link to="/" style="display: flex;align-items: center;height: inherit"><img src="@/assets/images/logo.svg" class="w-105 h-33" style="margin-top: -2px"></router-link>
						</el-menu-item>
						<el-menu-item class="hidden-sm-and-down" index="1">
							<router-link to="/">首页</router-link>
						</el-menu-item>
						<el-menu-item class="hidden-sm-and-down" index="2">
							<router-link to="/portal/ai">AI平台</router-link>
						</el-menu-item>
						<el-menu-item class="hidden-sm-and-down" index="3">
							<router-link to="/portal/lm">大模型AI</router-link>
						</el-menu-item>
						<el-menu-item class="hidden-sm-and-down" index="4">
							<router-link to="/portal/lmaes">大模型应用引擎系统</router-link>
						</el-menu-item>
						<el-submenu index="4" class="hidden-sm-and-down nav-submenu">
							<template slot="title">AI教育</template>
							<router-link to="/portal/edu">
								<el-menu-item index="5-1">
									AI教育
								</el-menu-item>
							</router-link>
							<el-menu-item index="5-2">
								<a href="https://www.zhipoai.com/" target="_blank" style="color:#fff;">智泊AI</a>
							</el-menu-item>
						</el-submenu>
						<el-menu-item class="hidden-sm-and-down" index="6">
							<router-link to="/introduction">关于公司</router-link>
						</el-menu-item>
            <el-menu-item class="hidden-sm-and-down" index="7">
              <router-link to="/news">最新资讯</router-link>
            </el-menu-item>
            <el-menu-item class="hidden-sm-and-down" index="8">
              <router-link to="/contact-us-new">联系我们</router-link>
            </el-menu-item>
					</el-menu>
					<div class="reg-login hidden-sm-and-down">
						<a href="https://account.mopaas.com/registerPublic.jsp" style="color:#fff;display: none">注册</a>
						<el-divider direction="vertical" style="color :transparent"></el-divider>
					</div>
					<el-menu class="menu-demo hidden-md-and-up reg-login" background-color="#04375d" text-color="#fff" mode="horizontal">
						<el-submenu index="1">
							<template slot="title">
								<font-awesome-icon icon="bars" size="lg" />
							</template>
							<a href="/news">
								<el-menu-item index="1-2">资讯</el-menu-item>
							</a>
							<a href="/more/introduction">
								<el-menu-item index="1-3">更多</el-menu-item>
							</a>
							<a href="https://account.mopaas.com/registerPublic.jsp">
								<el-menu-item index="1-4" style="display: none">注册</el-menu-item>
							</a>
						</el-submenu>
					</el-menu>
				</div>
		</div>
	</el-header>
</template>

<script>
	export default {
		name: 'Header'
	}
</script>

<style>
	.el-header {
		width: 100%;
		position: fixed;
		z-index: 999;
	}

	.nav-bg-color {
		background-color: #060D27;
	}

	div.grid-content {
		height: 72px;
    display: flex;
    align-items: center;
	}

	.logo {
		float: left;
		/* margin-left: 20px; */
	}

	.reg-login {
		float: right;
		/*margin-right: 20px;*/
	}

	.el-menu.el-menu--horizontal {
		border-bottom: 0px;
	}

	.el-menu--horizontal>.el-menu-item {
		border-bottom: 0px;
		margin-right: 56px;
	}

	.el-menu.el-menu--horizontal>.el-menu-item.is-active,
	.el-menu--horizontal>.el-submenu.is-active .el-submenu__title,
	.el-menu--horizontal>.el-submenu .el-submenu__title {
		border-bottom: 0px;
		color: #FFFFFF;
	}

	.el-menu--horizontal>.el-menu-item:hover,
	.el-menu--horizontal .el-submenu__title:hover {
		background: transparent !important;
		color: #409EFF !important;
	}

	.menu-demo:not(.el-menu--collapse) {
		width: 60px;
	}

	.el-submenu__title i {
		color: #fff;
	}

	.el-submenu__title i.el-icon-arrow-down {
		color: transparent;
	}

	/* .nav-submenu {
		background-color: transparent;
	} */
  .el-menu--horizontal .el-submenu {
    margin-right: 36px;
  }
	.menu-demo .el-submenu.is-active .el-submenu__title,
	.el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title {
		color: #fff;
	}

	.nav-bg-color a {
		color: #FFFFFF !important;
	}

	@media(max-width:992px) {
		.nav-bg-color img {
			width: 70px;
		}
	}

	.nav-main {
		display:flex;
		width: 1480px;
		max-width: 90%;
		margin: 0 auto;
		justify-content: space-between;
    align-items: center;
	}
	.reg-login .el-divider{
		color: transparent;
		background: transparent;
	}
</style>
<style>.w-105 {width: 105px;}
.h-33 {height: 33px;}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue